// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Landing page
 */

.landing_page__0FiAS {
  padding-bottom: 0;
  --container: calc(1160px + 2 * var(--gutter));
  --brand-shadow: 0 24px 60px -24px rgba(122, 24, 71, 0.45);
  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);
}

/* Hero group */
div.landing_heroBlock__mxQqk {
  gap: var(--space-6);
}

/* Every other contained group */
div.landing_block__xr\\+br {
  gap: clamp(56px, 7vw, 96px);
  padding-block: clamp(48px, 6vw, 88px) clamp(56px, 7vw, 104px);
}

/* Perspective control */
.landing_toggleRow__yF0Gf {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 820px) {
  .landing_toggleRow__yF0Gf > * {
    display: grid;
    width: 100%;
  }
}

/* ---------- Hero ---------- */
.landing_hero__yXxmC {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(0, 0.92fr);
  min-height: min(520px, 78dvh);
  border-radius: 24px;
  overflow: hidden;
  isolation: isolate;
  color: var(--text-on-primary);
  background:
    radial-gradient(90% 120% at 0% 0%, rgba(255, 255, 255, 0.14) 0%, transparent 55%),
    radial-gradient(70% 90% at 30% 120%, rgba(21, 92, 107, 0.45) 0%, transparent 60%),
    linear-gradient(160deg, var(--primary-light) 0%, var(--primary) 45%, var(--primary-dark) 100%);
  box-shadow: var(--brand-shadow);
}

.landing_heroCopy__kEY8t {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--space-5);
  padding: clamp(28px, 5vw, 64px);
  min-width: 0;
}

.landing_heroLabel__DzWJ\\+ {
  align-self: flex-start;
  padding: 6px 12px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.14);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.22);
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

h1.landing_heroTitle__hH0D7 {
  margin: 0;
  color: inherit;
  font-size: clamp(2.25rem, 1.2rem + 3.6vw, 4.1rem);
  font-weight: 800;
  line-height: 1.04;
  letter-spacing: -0.035em;
  text-wrap: balance;
}

.landing_heroAccent__1XH0E {
  color: var(--surface-selected);
}

.landing_heroLead__MIpJl {
  margin: 0;
  max-width: 44ch;
  font-size: clamp(1.0625rem, 0.98rem + 0.35vw, 1.25rem);
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.9);
  text-wrap: pretty;
}

.landing_heroActions__mzobN {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  margin-top: var(--space-2);
}

.landing_heroCta__Yodu8 {
  font-weight: 700;
  box-shadow: 0 10px 24px -10px rgba(40, 6, 24, 0.55);
  transition:
    background-color var(--dur-fast) var(--ease-standard),
    transform var(--dur-med) var(--ease-out),
    box-shadow var(--dur-med) var(--ease-out);
}

.landing_heroCta__Yodu8 svg {
  transition: transform var(--dur-med) var(--ease-out);
}

.landing_heroCta__Yodu8:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 30px -12px rgba(40, 6, 24, 0.6);
}

.landing_heroCta__Yodu8:hover svg {
  transform: translateX(3px);
}

.landing_heroCta__Yodu8:active {
  transform: translateY(0) scale(0.98);
}

/* Outline button for use on the magenta panels. */
.landing_heroGhost__e\\+3DF {
  --btn-bg: transparent;
  --btn-bg-hover: rgba(255, 255, 255, 0.12);
  --btn-fg: #fff;
  --btn-border: rgba(255, 255, 255, 0.55);
  --btn-shadow: none;
}

.landing_heroGhost__e\\+3DF:active {
  transform: scale(0.98);
}

.landing_heroCta__Yodu8:focus-visible,
.landing_heroGhost__e\\+3DF:focus-visible {
  outline: 3px solid #fff;
  outline-offset: 3px;
}

.landing_heroMedia__zx7By {
  position: relative;
  min-height: 320px;
  background: #ececec;
}

.landing_heroMedia__zx7By > img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 40% 55%;
}

/* A soft seam so the photo melts into the panel instead of cutting hard. */
.landing_heroMedia__zx7By::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 10%;
  z-index: 1;
  background: linear-gradient(90deg, rgba(122, 24, 71, 0.22), transparent);
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .landing_heroCopy__kEY8t > * {
    opacity: 0;
    animation: landing_heroIn__6j8NB 0.8s var(--ease-out) forwards;
  }
  .landing_heroCopy__kEY8t > :nth-child(2) { animation-delay: 80ms; }
  .landing_heroCopy__kEY8t > :nth-child(3) { animation-delay: 160ms; }
  .landing_heroCopy__kEY8t > :nth-child(4) { animation-delay: 240ms; }

  .landing_heroMedia__zx7By > img {
    animation: landing_heroImg__A71C9 1.2s var(--ease-out) both;
  }
}

@keyframes landing_heroIn__6j8NB {
  from { opacity: 0; transform: translateY(18px); }
  to { opacity: 1; transform: none; }
}

@keyframes landing_heroImg__A71C9 {
  from { opacity: 0; transform: scale(1.06); }
  to { opacity: 1; transform: none; }
}

@media (max-width: 820px) {
  .landing_hero__yXxmC {
    grid-template-columns: minmax(0, 1fr);
    min-height: 0;
    border-radius: 20px;
  }

  .landing_heroMedia__zx7By {
    order: -1;
    min-height: 0;
    aspect-ratio: 4 / 3;
  }

  .landing_heroMedia__zx7By::before {
    inset: auto 0 0 0;
    width: auto;
    height: 30%;
    background: linear-gradient(0deg, rgba(122, 24, 71, 0.4), transparent);
  }

  .landing_heroCopy__kEY8t {
    gap: var(--space-4);
    padding: var(--space-8) var(--space-6) var(--space-8);
  }
}

@media (max-width: 480px) {
  .landing_heroActions__mzobN > * {
    flex: 1 1 100%;
  }
}

/* ---------- Section heads ---------- */
.landing_sectionHead__NrEjQ {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  max-width: 680px;
  margin-bottom: clamp(28px, 3.5vw, 44px);
}

h2.landing_sectionTitle__6-ftV {
  font-size: clamp(1.75rem, 1.2rem + 1.9vw, 2.75rem);
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.03em;
  text-wrap: balance;
}

.landing_sectionLead__DaygC {
  font-size: clamp(1.0625rem, 1rem + 0.25vw, 1.1875rem);
  line-height: 1.6;
  color: var(--text-secondary);
  max-width: 52ch;
  text-wrap: pretty;
}

/* ---------- Kit bento ---------- */
.landing_bento__\\+1Le6 {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  grid-auto-rows: minmax(260px, auto);
  gap: var(--space-5);
}

.landing_cell__M9Mdd {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  border-radius: 20px;
  overflow: hidden;
  padding: clamp(22px, 2.6vw, 32px);
  transition: transform var(--dur-med) var(--ease-out), box-shadow var(--dur-med) var(--ease-out);
}

.landing_cell__M9Mdd:hover {
  transform: translateY(-4px);
}

.landing_cell__M9Mdd h3 {
  margin: 0;
  font-size: clamp(1.25rem, 1.1rem + 0.5vw, 1.5rem);
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: inherit;
}

.landing_cell__M9Mdd p {
  margin: 0;
  max-width: 40ch;
  font-size: 1rem;
  line-height: 1.6;
}

.landing_cellIcon__K9TjY {
  width: 26px;
  height: 26px;
  margin-bottom: var(--space-2);
}

/* App: full-bleed photo with the copy on a scrim. */
.landing_cellApp__Y902o {
  grid-column: span 4;
  min-height: 400px;
  justify-content: flex-end;
  color: #fff;
  background: var(--primary-dark);
}

.landing_cellApp__Y902o > img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 30% 50%;
  transition: transform 0.8s var(--ease-out);
}

.landing_cellApp__Y902o:hover > img {
  transform: scale(1.03);
}

.landing_cellApp__Y902o::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent 30%, rgba(60, 10, 35, 0.86) 100%);
}

.landing_cellAppText__3jdf0 {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.landing_cellAppText__3jdf0 p {
  color: rgba(255, 255, 255, 0.92);
}

/* Nine activities: the big number is the visual. */
.landing_cellCount__LxSXZ {
  grid-column: span 2;
  justify-content: flex-end;
  color: #fff;
  background:
    radial-gradient(100% 80% at 100% 0%, rgba(255, 255, 255, 0.16), transparent 60%),
    linear-gradient(170deg, var(--primary) 0%, var(--primary-dark) 100%);
  box-shadow: var(--brand-shadow);
}

.landing_cellCount__LxSXZ p {
  color: rgba(255, 255, 255, 0.88);
}

.landing_bigNum__5sgSF {
  font-size: clamp(6rem, 4rem + 6vw, 9rem);
  font-weight: 800;
  line-height: 0.85;
  letter-spacing: -0.06em;
  font-variant-numeric: tabular-nums;
  margin-bottom: auto;
}

.landing_cellLink__clfII {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: var(--space-3);
  min-height: 44px;
  align-self: flex-start;
  color: #fff;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.landing_cellLink__clfII svg {
  transition: transform var(--dur-med) var(--ease-out);
}

.landing_cellLink__clfII:hover svg {
  transform: translateX(3px);
}

.landing_cellLink__clfII:focus-visible {
  outline: 3px solid #fff;
  outline-offset: 2px;
  border-radius: 4px;
}

/* 3D-printed tools: photo on top, copy below. */
.landing_cellTools__2FgkG {
  grid-column: span 2;
  padding: 0;
  background: var(--bg-tertiary);
  box-shadow: inset 0 0 0 1px var(--border);
  color: var(--text-primary);
}

.landing_cellToolsMedia__0\\+RI\\+ {
  aspect-ratio: 16 / 10;
  overflow: hidden;
  background: var(--gray-200);
}

.landing_cellToolsMedia__0\\+RI\\+ img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.landing_cellBody__WHCTN {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: clamp(20px, 2.4vw, 28px);
}

.landing_cellTools__2FgkG p,
.landing_cellProgress__yKhCF p {
  color: var(--text-secondary);
}

.landing_cellTools__2FgkG .landing_cellIcon__K9TjY,
.landing_cellProgress__yKhCF .landing_cellIcon__K9TjY {
  color: var(--primary);
}

/* Progress: brand wash. */
.landing_cellProgress__yKhCF {
  grid-column: span 4;
  justify-content: center;
  color: var(--text-primary);
  background:
    radial-gradient(60% 90% at 100% 100%, var(--surface-selected-soft) 0%, transparent 70%),
    var(--surface-brand-wash);
  box-shadow: inset 0 0 0 1px var(--surface-selected-soft);
}

.landing_cellProgress__yKhCF {
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(0, 0.75fr);
  padding: 0;
}

.landing_cellProgressText__Qgvl\\+ {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--space-2);
  padding: clamp(22px, 2.6vw, 36px);
}

.landing_cellProgressMedia__O13oD {
  position: relative;
  min-height: 220px;
  background: var(--gray-200);
}

.landing_cellProgressMedia__O13oD img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 20%;
}

.landing_cellProgress__yKhCF h3 {
  font-size: clamp(1.5rem, 1.2rem + 1vw, 2rem);
}

.landing_progressPoints__hdwJF {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3) var(--space-8);
  margin: var(--space-4) 0 0;
  padding: 0;
  list-style: none;
}

.landing_progressPoints__hdwJF li {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  color: var(--primary-dark);
}

.landing_progressPoints__hdwJF svg {
  width: 20px;
  height: 20px;
  color: var(--primary);
}

@media (max-width: 960px) {
  .landing_bento__\\+1Le6 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .landing_cellApp__Y902o,
  .landing_cellProgress__yKhCF {
    grid-column: span 2;
  }
  .landing_cellCount__LxSXZ,
  .landing_cellTools__2FgkG {
    grid-column: span 1;
  }
}

@media (max-width: 600px) {
  .landing_bento__\\+1Le6 {
    grid-template-columns: minmax(0, 1fr);
    grid-auto-rows: auto;
    gap: var(--space-4);
  }
  .landing_cellApp__Y902o,
  .landing_cellProgress__yKhCF,
  .landing_cellCount__LxSXZ,
  .landing_cellTools__2FgkG {
    grid-column: auto;
  }
  .landing_cellApp__Y902o {
    min-height: 340px;
  }
  .landing_cellProgress__yKhCF {
    grid-template-columns: minmax(0, 1fr);
  }
  .landing_cellProgressMedia__O13oD {
    order: -1;
    min-height: 0;
    aspect-ratio: 16 / 10;
  }
  .landing_cellCount__LxSXZ {
    min-height: 0;
  }
  .landing_bigNum__5sgSF {
    font-size: 6rem;
    margin-bottom: var(--space-2);
  }
}

@media (prefers-reduced-motion: reduce) {
  .landing_cell__M9Mdd:hover,
  .landing_cellApp__Y902o:hover > img {
    transform: none;
  }
}

/* ---------- Nine activities ---------- */
.landing_activities__Ed0\\+D {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  gap: clamp(28px, 5vw, 80px);
  align-items: start;
  scroll-margin-top: 96px;
}

.landing_activitiesHead__gyqX4 {
  position: sticky;
  top: 96px;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.landing_activitiesNum__AyYGv {
  font-size: clamp(7rem, 4rem + 9vw, 12rem);
  font-weight: 800;
  line-height: 0.8;
  letter-spacing: -0.07em;
  color: transparent;
  -webkit-text-stroke: 2px var(--primary);
  margin-bottom: var(--space-3);
}

.landing_groups__CnAxe {
  display: flex;
  flex-direction: column;
}

.landing_group__KDl6j {
  display: grid;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
  gap: var(--space-4) var(--space-8);
  padding: clamp(22px, 2.6vw, 32px) 0;
}

.landing_group__KDl6j + .landing_group__KDl6j {
  border-top: 1px solid var(--border);
}

.landing_groupHead__q\\+Fdj {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

h3.landing_groupName__jTxyD {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--primary);
}

.landing_groupSummary__C9jGo {
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--text-secondary);
}

.landing_chips__F1Edf {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.landing_chip__g55-k {
  padding: 10px 16px;
  border-radius: var(--radius-md);
  background: var(--surface-brand-wash);
  box-shadow: inset 0 0 0 1px var(--surface-selected-soft);
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--text-primary);
  transition: background-color var(--dur-fast) var(--ease-standard), transform var(--dur-fast) var(--ease-standard);
}

.landing_chip__g55-k:hover {
  background: var(--surface-selected-soft);
}

@media (max-width: 900px) {
  .landing_activities__Ed0\\+D {
    grid-template-columns: minmax(0, 1fr);
  }
  .landing_activitiesHead__gyqX4 {
    position: static;
  }
  .landing_activitiesNum__AyYGv {
    font-size: 6.5rem;
  }
}

@media (max-width: 600px) {
  .landing_group__KDl6j {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--space-3);
  }
  .landing_chip__g55-k {
    padding: 8px 12px;
    font-size: 0.875rem;
  }
}

/* ---------- How you use it ---------- */
.landing_steps__IPjIp {
  position: relative;
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-8);
}

.landing_step__gUCH0 {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding-right: var(--space-6);
}

.landing_step__gUCH0:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 22px;
  left: 56px;
  right: calc(-1 * var(--space-8));
  height: 2px;
  background: linear-gradient(90deg, var(--surface-selected), var(--surface-selected-soft));
}

.landing_stepNum__w1RAX {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-bottom: var(--space-2);
  border-radius: var(--radius-full);
  background: var(--primary);
  color: var(--text-on-primary);
  font-size: 1.125rem;
  font-weight: 800;
  /* A ring of page colour so the rule appears to pass behind the number. */
  box-shadow: 0 0 0 8px var(--bg);
}

.landing_stepTitle__kwapm {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 800;
  line-height: 1.3;
  letter-spacing: -0.015em;
  color: var(--text-primary);
}

.landing_stepBody__kdL25 {
  font-size: 1rem;
  line-height: 1.6;
  color: var(--text-secondary);
  max-width: 40ch;
}

@media (max-width: 820px) {
  .landing_steps__IPjIp {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--space-8);
  }

  .landing_step__gUCH0:not(:last-child)::after {
    display: none;
  }

  .landing_step__gUCH0 {
    padding-right: 0;
  }
}

/* Video */
.landing_video__zfnWV {
  scroll-margin-top: 96px;
}

/* ---------- Who it's for ---------- */
.landing_audienceRows__lPUC4 {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.landing_rowAction__lePzz {
  font-size: 0.875rem;
  font-weight: 600;
}

@media (max-width: 480px) {
  .landing_rowAction__lePzz {
    display: none;
  }
}

/* ---------- Closing CTA ---------- */
.landing_closing__wBtbk {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) auto;
  align-items: center;
  gap: var(--space-8);
  padding: clamp(32px, 5vw, 64px);
  border-radius: 24px;
  color: #fff;
  background:
    radial-gradient(80% 140% at 100% 0%, rgba(255, 255, 255, 0.14), transparent 60%),
    linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
  box-shadow: var(--brand-shadow);
}

h2.landing_closingTitle__hdBIy {
  margin: 0;
  color: inherit;
  font-size: clamp(1.9rem, 1.2rem + 2.4vw, 3rem);
  font-weight: 800;
  line-height: 1.06;
  letter-spacing: -0.035em;
}

.landing_closingLead__hvDBm {
  margin: var(--space-3) 0 0;
  max-width: 44ch;
  font-size: 1.0625rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.9);
}

.landing_closingActions__8T\\+Hh {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

@media (max-width: 820px) {
  .landing_closing__wBtbk {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--space-6);
  }
}

@media (max-width: 480px) {
  .landing_closingActions__8T\\+Hh > * {
    flex: 1 1 100%;
  }
}

/* Phones: tighter type for the long-form bits. */
@media (max-width: 560px) {
  div.landing_heroBlock__mxQqk {
    gap: var(--space-5);
  }

  .landing_sectionHead__NrEjQ {
    margin-bottom: var(--space-6);
  }

  .landing_stepTitle__kwapm {
    font-size: 1.0625rem;
  }

  .landing_stepBody__kdL25 {
    font-size: 0.9375rem;
  }

  /* Steps: number beside the text, not stacked above it. */
  .landing_steps__IPjIp {
    gap: var(--space-6);
  }

  .landing_step__gUCH0 {
    display: grid;
    grid-template-columns: 36px minmax(0, 1fr);
    column-gap: var(--space-4);
    row-gap: 2px;
  }

  .landing_stepNum__w1RAX {
    grid-row: span 2;
    width: 36px;
    height: 36px;
    margin-bottom: 0;
    font-size: 0.9375rem;
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/landing.module.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,iBAAiB;EACjB,6CAA6C;EAC7C,yDAAyD;EACzD,yCAAyC;AAC3C;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,2BAA2B;EAC3B,6DAA6D;AAC/D;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;IACb,WAAW;EACb;AACF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,aAAa;EACb,0DAA0D;EAC1D,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B;;;kGAGgG;EAChG,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,qDAAqD;EACrD,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iDAAiD;EACjD,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sDAAsD;EACtD,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,mDAAmD;EACnD;;;6CAG2C;AAC7C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kDAAkD;AAClD;EACE,qBAAqB;EACrB,yCAAyC;EACzC,cAAc;EACd,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,UAAU;EACV,wEAAwE;EACxE,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;IACV,8DAA+C;EACjD;EACA,2CAA4B,qBAAqB,EAAE;EACnD,2CAA4B,sBAAsB,EAAE;EACpD,2CAA4B,sBAAsB,EAAE;;EAEpD;IACE,2DAA4C;EAC9C;AACF;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE;IACE,qCAAqC;IACrC,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,sEAAsE;EACxE;;EAEA;IACE,mBAAmB;IACnB,qDAAqD;EACvD;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,gDAAgD;EAChD,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,+FAA+F;AACjG;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,iDAAiD;EACjD,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,iFAAiF;AACnF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX;;wEAEsE;EACtE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,UAAU;EACV,8BAA8B;EAC9B,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B;;6BAE2B;EAC3B,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kCAAkC;EAClC,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE;IACE,gDAAgD;EAClD;EACA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,oBAAoB;IACpB,mBAAmB;EACrB;EACA;;;;IAIE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,SAAS;IACT,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,6BAA6B;EAC/B;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,wDAAwD;EACxD,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,wDAAwD;EACxD,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,iHAAiH;AACnH;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,WAAW;EACX,yFAAyF;AAC3F;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,iCAAiC;EACjC,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,yEAAyE;EACzE,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,UAAU;AACV;EACE,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX;;wEAEsE;EACtE,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,8CAA8C;EAC9C,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;IACrC,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA,yDAAyD;EACzD;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,0CAA0C;IAC1C,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;AACF","sourcesContent":["/*\n * Landing page\n */\n\n.page {\n  padding-bottom: 0;\n  --container: calc(1160px + 2 * var(--gutter));\n  --brand-shadow: 0 24px 60px -24px rgba(122, 24, 71, 0.45);\n  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n/* Hero group */\ndiv.heroBlock {\n  gap: var(--space-6);\n}\n\n/* Every other contained group */\ndiv.block {\n  gap: clamp(56px, 7vw, 96px);\n  padding-block: clamp(48px, 6vw, 88px) clamp(56px, 7vw, 104px);\n}\n\n/* Perspective control */\n.toggleRow {\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media (max-width: 820px) {\n  .toggleRow > * {\n    display: grid;\n    width: 100%;\n  }\n}\n\n/* ---------- Hero ---------- */\n.hero {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(0, 1.08fr) minmax(0, 0.92fr);\n  min-height: min(520px, 78dvh);\n  border-radius: 24px;\n  overflow: hidden;\n  isolation: isolate;\n  color: var(--text-on-primary);\n  background:\n    radial-gradient(90% 120% at 0% 0%, rgba(255, 255, 255, 0.14) 0%, transparent 55%),\n    radial-gradient(70% 90% at 30% 120%, rgba(21, 92, 107, 0.45) 0%, transparent 60%),\n    linear-gradient(160deg, var(--primary-light) 0%, var(--primary) 45%, var(--primary-dark) 100%);\n  box-shadow: var(--brand-shadow);\n}\n\n.heroCopy {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: var(--space-5);\n  padding: clamp(28px, 5vw, 64px);\n  min-width: 0;\n}\n\n.heroLabel {\n  align-self: flex-start;\n  padding: 6px 12px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.14);\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.22);\n  font-size: 0.8125rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\nh1.heroTitle {\n  margin: 0;\n  color: inherit;\n  font-size: clamp(2.25rem, 1.2rem + 3.6vw, 4.1rem);\n  font-weight: 800;\n  line-height: 1.04;\n  letter-spacing: -0.035em;\n  text-wrap: balance;\n}\n\n.heroAccent {\n  color: var(--surface-selected);\n}\n\n.heroLead {\n  margin: 0;\n  max-width: 44ch;\n  font-size: clamp(1.0625rem, 0.98rem + 0.35vw, 1.25rem);\n  line-height: 1.55;\n  color: rgba(255, 255, 255, 0.9);\n  text-wrap: pretty;\n}\n\n.heroActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  margin-top: var(--space-2);\n}\n\n.heroCta {\n  font-weight: 700;\n  box-shadow: 0 10px 24px -10px rgba(40, 6, 24, 0.55);\n  transition:\n    background-color var(--dur-fast) var(--ease-standard),\n    transform var(--dur-med) var(--ease-out),\n    box-shadow var(--dur-med) var(--ease-out);\n}\n\n.heroCta svg {\n  transition: transform var(--dur-med) var(--ease-out);\n}\n\n.heroCta:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 16px 30px -12px rgba(40, 6, 24, 0.6);\n}\n\n.heroCta:hover svg {\n  transform: translateX(3px);\n}\n\n.heroCta:active {\n  transform: translateY(0) scale(0.98);\n}\n\n/* Outline button for use on the magenta panels. */\n.heroGhost {\n  --btn-bg: transparent;\n  --btn-bg-hover: rgba(255, 255, 255, 0.12);\n  --btn-fg: #fff;\n  --btn-border: rgba(255, 255, 255, 0.55);\n  --btn-shadow: none;\n}\n\n.heroGhost:active {\n  transform: scale(0.98);\n}\n\n.heroCta:focus-visible,\n.heroGhost:focus-visible {\n  outline: 3px solid #fff;\n  outline-offset: 3px;\n}\n\n.heroMedia {\n  position: relative;\n  min-height: 320px;\n  background: #ececec;\n}\n\n.heroMedia > img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: 40% 55%;\n}\n\n/* A soft seam so the photo melts into the panel instead of cutting hard. */\n.heroMedia::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 10%;\n  z-index: 1;\n  background: linear-gradient(90deg, rgba(122, 24, 71, 0.22), transparent);\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .heroCopy > * {\n    opacity: 0;\n    animation: heroIn 0.8s var(--ease-out) forwards;\n  }\n  .heroCopy > :nth-child(2) { animation-delay: 80ms; }\n  .heroCopy > :nth-child(3) { animation-delay: 160ms; }\n  .heroCopy > :nth-child(4) { animation-delay: 240ms; }\n\n  .heroMedia > img {\n    animation: heroImg 1.2s var(--ease-out) both;\n  }\n}\n\n@keyframes heroIn {\n  from { opacity: 0; transform: translateY(18px); }\n  to { opacity: 1; transform: none; }\n}\n\n@keyframes heroImg {\n  from { opacity: 0; transform: scale(1.06); }\n  to { opacity: 1; transform: none; }\n}\n\n@media (max-width: 820px) {\n  .hero {\n    grid-template-columns: minmax(0, 1fr);\n    min-height: 0;\n    border-radius: 20px;\n  }\n\n  .heroMedia {\n    order: -1;\n    min-height: 0;\n    aspect-ratio: 4 / 3;\n  }\n\n  .heroMedia::before {\n    inset: auto 0 0 0;\n    width: auto;\n    height: 30%;\n    background: linear-gradient(0deg, rgba(122, 24, 71, 0.4), transparent);\n  }\n\n  .heroCopy {\n    gap: var(--space-4);\n    padding: var(--space-8) var(--space-6) var(--space-8);\n  }\n}\n\n@media (max-width: 480px) {\n  .heroActions > * {\n    flex: 1 1 100%;\n  }\n}\n\n/* ---------- Section heads ---------- */\n.sectionHead {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  max-width: 680px;\n  margin-bottom: clamp(28px, 3.5vw, 44px);\n}\n\nh2.sectionTitle {\n  font-size: clamp(1.75rem, 1.2rem + 1.9vw, 2.75rem);\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -0.03em;\n  text-wrap: balance;\n}\n\n.sectionLead {\n  font-size: clamp(1.0625rem, 1rem + 0.25vw, 1.1875rem);\n  line-height: 1.6;\n  color: var(--text-secondary);\n  max-width: 52ch;\n  text-wrap: pretty;\n}\n\n/* ---------- Kit bento ---------- */\n.bento {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  grid-auto-rows: minmax(260px, auto);\n  gap: var(--space-5);\n}\n\n.cell {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  border-radius: 20px;\n  overflow: hidden;\n  padding: clamp(22px, 2.6vw, 32px);\n  transition: transform var(--dur-med) var(--ease-out), box-shadow var(--dur-med) var(--ease-out);\n}\n\n.cell:hover {\n  transform: translateY(-4px);\n}\n\n.cell h3 {\n  margin: 0;\n  font-size: clamp(1.25rem, 1.1rem + 0.5vw, 1.5rem);\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: inherit;\n}\n\n.cell p {\n  margin: 0;\n  max-width: 40ch;\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n.cellIcon {\n  width: 26px;\n  height: 26px;\n  margin-bottom: var(--space-2);\n}\n\n/* App: full-bleed photo with the copy on a scrim. */\n.cellApp {\n  grid-column: span 4;\n  min-height: 400px;\n  justify-content: flex-end;\n  color: #fff;\n  background: var(--primary-dark);\n}\n\n.cellApp > img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: 30% 50%;\n  transition: transform 0.8s var(--ease-out);\n}\n\n.cellApp:hover > img {\n  transform: scale(1.03);\n}\n\n.cellApp::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, transparent 30%, rgba(60, 10, 35, 0.86) 100%);\n}\n\n.cellAppText {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.cellAppText p {\n  color: rgba(255, 255, 255, 0.92);\n}\n\n/* Nine activities: the big number is the visual. */\n.cellCount {\n  grid-column: span 2;\n  justify-content: flex-end;\n  color: #fff;\n  background:\n    radial-gradient(100% 80% at 100% 0%, rgba(255, 255, 255, 0.16), transparent 60%),\n    linear-gradient(170deg, var(--primary) 0%, var(--primary-dark) 100%);\n  box-shadow: var(--brand-shadow);\n}\n\n.cellCount p {\n  color: rgba(255, 255, 255, 0.88);\n}\n\n.bigNum {\n  font-size: clamp(6rem, 4rem + 6vw, 9rem);\n  font-weight: 800;\n  line-height: 0.85;\n  letter-spacing: -0.06em;\n  font-variant-numeric: tabular-nums;\n  margin-bottom: auto;\n}\n\n.cellLink {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: var(--space-3);\n  min-height: 44px;\n  align-self: flex-start;\n  color: #fff;\n  font-weight: 700;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.cellLink svg {\n  transition: transform var(--dur-med) var(--ease-out);\n}\n\n.cellLink:hover svg {\n  transform: translateX(3px);\n}\n\n.cellLink:focus-visible {\n  outline: 3px solid #fff;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n/* 3D-printed tools: photo on top, copy below. */\n.cellTools {\n  grid-column: span 2;\n  padding: 0;\n  background: var(--bg-tertiary);\n  box-shadow: inset 0 0 0 1px var(--border);\n  color: var(--text-primary);\n}\n\n.cellToolsMedia {\n  aspect-ratio: 16 / 10;\n  overflow: hidden;\n  background: var(--gray-200);\n}\n\n.cellToolsMedia img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.cellBody {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  padding: clamp(20px, 2.4vw, 28px);\n}\n\n.cellTools p,\n.cellProgress p {\n  color: var(--text-secondary);\n}\n\n.cellTools .cellIcon,\n.cellProgress .cellIcon {\n  color: var(--primary);\n}\n\n/* Progress: brand wash. */\n.cellProgress {\n  grid-column: span 4;\n  justify-content: center;\n  color: var(--text-primary);\n  background:\n    radial-gradient(60% 90% at 100% 100%, var(--surface-selected-soft) 0%, transparent 70%),\n    var(--surface-brand-wash);\n  box-shadow: inset 0 0 0 1px var(--surface-selected-soft);\n}\n\n.cellProgress {\n  display: grid;\n  grid-template-columns: minmax(0, 1.25fr) minmax(0, 0.75fr);\n  padding: 0;\n}\n\n.cellProgressText {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: var(--space-2);\n  padding: clamp(22px, 2.6vw, 36px);\n}\n\n.cellProgressMedia {\n  position: relative;\n  min-height: 220px;\n  background: var(--gray-200);\n}\n\n.cellProgressMedia img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: 50% 20%;\n}\n\n.cellProgress h3 {\n  font-size: clamp(1.5rem, 1.2rem + 1vw, 2rem);\n}\n\n.progressPoints {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-3) var(--space-8);\n  margin: var(--space-4) 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.progressPoints li {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 700;\n  color: var(--primary-dark);\n}\n\n.progressPoints svg {\n  width: 20px;\n  height: 20px;\n  color: var(--primary);\n}\n\n@media (max-width: 960px) {\n  .bento {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .cellApp,\n  .cellProgress {\n    grid-column: span 2;\n  }\n  .cellCount,\n  .cellTools {\n    grid-column: span 1;\n  }\n}\n\n@media (max-width: 600px) {\n  .bento {\n    grid-template-columns: minmax(0, 1fr);\n    grid-auto-rows: auto;\n    gap: var(--space-4);\n  }\n  .cellApp,\n  .cellProgress,\n  .cellCount,\n  .cellTools {\n    grid-column: auto;\n  }\n  .cellApp {\n    min-height: 340px;\n  }\n  .cellProgress {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .cellProgressMedia {\n    order: -1;\n    min-height: 0;\n    aspect-ratio: 16 / 10;\n  }\n  .cellCount {\n    min-height: 0;\n  }\n  .bigNum {\n    font-size: 6rem;\n    margin-bottom: var(--space-2);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cell:hover,\n  .cellApp:hover > img {\n    transform: none;\n  }\n}\n\n/* ---------- Nine activities ---------- */\n.activities {\n  display: grid;\n  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);\n  gap: clamp(28px, 5vw, 80px);\n  align-items: start;\n  scroll-margin-top: 96px;\n}\n\n.activitiesHead {\n  position: sticky;\n  top: 96px;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.activitiesNum {\n  font-size: clamp(7rem, 4rem + 9vw, 12rem);\n  font-weight: 800;\n  line-height: 0.8;\n  letter-spacing: -0.07em;\n  color: transparent;\n  -webkit-text-stroke: 2px var(--primary);\n  margin-bottom: var(--space-3);\n}\n\n.groups {\n  display: flex;\n  flex-direction: column;\n}\n\n.group {\n  display: grid;\n  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);\n  gap: var(--space-4) var(--space-8);\n  padding: clamp(22px, 2.6vw, 32px) 0;\n}\n\n.group + .group {\n  border-top: 1px solid var(--border);\n}\n\n.groupHead {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\nh3.groupName {\n  margin: 0;\n  font-size: 1.375rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--primary);\n}\n\n.groupSummary {\n  margin: 0;\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n.chips {\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  gap: var(--space-2);\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.chip {\n  padding: 10px 16px;\n  border-radius: var(--radius-md);\n  background: var(--surface-brand-wash);\n  box-shadow: inset 0 0 0 1px var(--surface-selected-soft);\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  transition: background-color var(--dur-fast) var(--ease-standard), transform var(--dur-fast) var(--ease-standard);\n}\n\n.chip:hover {\n  background: var(--surface-selected-soft);\n}\n\n@media (max-width: 900px) {\n  .activities {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .activitiesHead {\n    position: static;\n  }\n  .activitiesNum {\n    font-size: 6.5rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .group {\n    grid-template-columns: minmax(0, 1fr);\n    gap: var(--space-3);\n  }\n  .chip {\n    padding: 8px 12px;\n    font-size: 0.875rem;\n  }\n}\n\n/* ---------- How you use it ---------- */\n.steps {\n  position: relative;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--space-8);\n}\n\n.step {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  padding-right: var(--space-6);\n}\n\n.step:not(:last-child)::after {\n  content: \"\";\n  position: absolute;\n  top: 22px;\n  left: 56px;\n  right: calc(-1 * var(--space-8));\n  height: 2px;\n  background: linear-gradient(90deg, var(--surface-selected), var(--surface-selected-soft));\n}\n\n.stepNum {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  margin-bottom: var(--space-2);\n  border-radius: var(--radius-full);\n  background: var(--primary);\n  color: var(--text-on-primary);\n  font-size: 1.125rem;\n  font-weight: 800;\n  /* A ring of page colour so the rule appears to pass behind the number. */\n  box-shadow: 0 0 0 8px var(--bg);\n}\n\n.stepTitle {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 800;\n  line-height: 1.3;\n  letter-spacing: -0.015em;\n  color: var(--text-primary);\n}\n\n.stepBody {\n  font-size: 1rem;\n  line-height: 1.6;\n  color: var(--text-secondary);\n  max-width: 40ch;\n}\n\n@media (max-width: 820px) {\n  .steps {\n    grid-template-columns: minmax(0, 1fr);\n    gap: var(--space-8);\n  }\n\n  .step:not(:last-child)::after {\n    display: none;\n  }\n\n  .step {\n    padding-right: 0;\n  }\n}\n\n/* Video */\n.video {\n  scroll-margin-top: 96px;\n}\n\n/* ---------- Who it's for ---------- */\n.audienceRows {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.rowAction {\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n@media (max-width: 480px) {\n  .rowAction {\n    display: none;\n  }\n}\n\n/* ---------- Closing CTA ---------- */\n.closing {\n  display: grid;\n  grid-template-columns: minmax(0, 1.3fr) auto;\n  align-items: center;\n  gap: var(--space-8);\n  padding: clamp(32px, 5vw, 64px);\n  border-radius: 24px;\n  color: #fff;\n  background:\n    radial-gradient(80% 140% at 100% 0%, rgba(255, 255, 255, 0.14), transparent 60%),\n    linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);\n  box-shadow: var(--brand-shadow);\n}\n\nh2.closingTitle {\n  margin: 0;\n  color: inherit;\n  font-size: clamp(1.9rem, 1.2rem + 2.4vw, 3rem);\n  font-weight: 800;\n  line-height: 1.06;\n  letter-spacing: -0.035em;\n}\n\n.closingLead {\n  margin: var(--space-3) 0 0;\n  max-width: 44ch;\n  font-size: 1.0625rem;\n  line-height: 1.55;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.closingActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n}\n\n@media (max-width: 820px) {\n  .closing {\n    grid-template-columns: minmax(0, 1fr);\n    gap: var(--space-6);\n  }\n}\n\n@media (max-width: 480px) {\n  .closingActions > * {\n    flex: 1 1 100%;\n  }\n}\n\n/* Phones: tighter type for the long-form bits. */\n@media (max-width: 560px) {\n  div.heroBlock {\n    gap: var(--space-5);\n  }\n\n  .sectionHead {\n    margin-bottom: var(--space-6);\n  }\n\n  .stepTitle {\n    font-size: 1.0625rem;\n  }\n\n  .stepBody {\n    font-size: 0.9375rem;\n  }\n\n  /* Steps: number beside the text, not stacked above it. */\n  .steps {\n    gap: var(--space-6);\n  }\n\n  .step {\n    display: grid;\n    grid-template-columns: 36px minmax(0, 1fr);\n    column-gap: var(--space-4);\n    row-gap: 2px;\n  }\n\n  .stepNum {\n    grid-row: span 2;\n    width: 36px;\n    height: 36px;\n    margin-bottom: 0;\n    font-size: 0.9375rem;\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `landing_page__0FiAS`,
	"heroBlock": `landing_heroBlock__mxQqk`,
	"block": `landing_block__xr+br`,
	"toggleRow": `landing_toggleRow__yF0Gf`,
	"hero": `landing_hero__yXxmC`,
	"heroCopy": `landing_heroCopy__kEY8t`,
	"heroLabel": `landing_heroLabel__DzWJ+`,
	"heroTitle": `landing_heroTitle__hH0D7`,
	"heroAccent": `landing_heroAccent__1XH0E`,
	"heroLead": `landing_heroLead__MIpJl`,
	"heroActions": `landing_heroActions__mzobN`,
	"heroCta": `landing_heroCta__Yodu8`,
	"heroGhost": `landing_heroGhost__e+3DF`,
	"heroMedia": `landing_heroMedia__zx7By`,
	"heroIn": `landing_heroIn__6j8NB`,
	"heroImg": `landing_heroImg__A71C9`,
	"sectionHead": `landing_sectionHead__NrEjQ`,
	"sectionTitle": `landing_sectionTitle__6-ftV`,
	"sectionLead": `landing_sectionLead__DaygC`,
	"bento": `landing_bento__+1Le6`,
	"cell": `landing_cell__M9Mdd`,
	"cellIcon": `landing_cellIcon__K9TjY`,
	"cellApp": `landing_cellApp__Y902o`,
	"cellAppText": `landing_cellAppText__3jdf0`,
	"cellCount": `landing_cellCount__LxSXZ`,
	"bigNum": `landing_bigNum__5sgSF`,
	"cellLink": `landing_cellLink__clfII`,
	"cellTools": `landing_cellTools__2FgkG`,
	"cellToolsMedia": `landing_cellToolsMedia__0+RI+`,
	"cellBody": `landing_cellBody__WHCTN`,
	"cellProgress": `landing_cellProgress__yKhCF`,
	"cellProgressText": `landing_cellProgressText__Qgvl+`,
	"cellProgressMedia": `landing_cellProgressMedia__O13oD`,
	"progressPoints": `landing_progressPoints__hdwJF`,
	"activities": `landing_activities__Ed0+D`,
	"activitiesHead": `landing_activitiesHead__gyqX4`,
	"activitiesNum": `landing_activitiesNum__AyYGv`,
	"groups": `landing_groups__CnAxe`,
	"group": `landing_group__KDl6j`,
	"groupHead": `landing_groupHead__q+Fdj`,
	"groupName": `landing_groupName__jTxyD`,
	"groupSummary": `landing_groupSummary__C9jGo`,
	"chips": `landing_chips__F1Edf`,
	"chip": `landing_chip__g55-k`,
	"steps": `landing_steps__IPjIp`,
	"step": `landing_step__gUCH0`,
	"stepNum": `landing_stepNum__w1RAX`,
	"stepTitle": `landing_stepTitle__kwapm`,
	"stepBody": `landing_stepBody__kdL25`,
	"video": `landing_video__zfnWV`,
	"audienceRows": `landing_audienceRows__lPUC4`,
	"rowAction": `landing_rowAction__lePzz`,
	"closing": `landing_closing__wBtbk`,
	"closingTitle": `landing_closingTitle__hdBIy`,
	"closingLead": `landing_closingLead__hvDBm`,
	"closingActions": `landing_closingActions__8T+Hh`
};
export default ___CSS_LOADER_EXPORT___;
